import { isTabRef } from '../typesActions/types';

export const addRefTabAction = (value) => {
	return { type: isTabRef.SELECTED_TAB, payload: value };
};
